import get from 'lodash.get';

const MAX_PRICE = 55000; // show PayPal if item costs <55000
const NET_PRICE_TYPE = 'NET';
const ACTIVE_STATUS = 'ACTIVE';

export function showPaypal({ item, user }) {
    const prices = get(item, 'pricing.prices') || [];
    const canSeeNetPrice = get(user, 'canSeeNetPrice');

    // loop until we find a valid price less than 55000
    let i;
    let show = false;
    for (i = 0; i < prices.length && !show; i++) {
        const priceNode = prices[i] || {};
        const price = get(priceNode, `amount.convertedAmounts.USD`);

        // price must be active
        if (!price || priceNode.status !== ACTIVE_STATUS) {
            continue;
        }
        // if its a net price, user must have permission to see it
        if (priceNode.type === NET_PRICE_TYPE && !canSeeNetPrice) {
            continue;
        }
        // price must be less than 55000
        show = price < MAX_PRICE;
    }

    return show;
}
